import { render, staticRenderFns } from "./notificaciones-oea.vue?vue&type=template&id=021c3956&scoped=true"
import script from "./notificaciones-oea.vue?vue&type=script&lang=js"
export * from "./notificaciones-oea.vue?vue&type=script&lang=js"
import style0 from "./notificaciones-oea.vue?vue&type=style&index=0&id=021c3956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c3956",
  null
  
)

export default component.exports